@let duration = durationLengthSg();
@let unit = durationUnitSg();

<div class="atn-ds-date-range-duration">
  <div class="atn-ds-input-field">
    <span class="atn-ds-input-field__label"> Duration </span>

    <div
      class="atn-ds-input-field__control atn-ds-input-field__control--duration"
    >
      <atn-ds-number
        class="atn-ds-date-range-duration__input"
        [value]="duration"
        (change)="durationLengthChangeHandler($event)"
        placeholder="INF"
      />
      <atn-ds-select-single
        class="atn-ds-date-range-duration__select"
        [disabled]="!duration"
        [value]="unit"
        (valueChange)="durationUnitChangeHandler($event)"
        [items]="durationUnits"
        [required]="true"
      />
    </div>
  </div>
</div>
